import React, {Component, useEffect, useState} from "react";
import {Session, User} from "../types/Types";
import {Card, Col} from "react-bootstrap";
import UserRow from "./UserRow";
import LeaderboardNav from "./LeaderboardNav";
import {addNumberSuffix, formatTime} from "../util/Util";
import PageTracking from "../auth/PageTracking";
import {V2GlassPanel} from "../shared/v2/V2Glass";
import LeaderboardV2Rows from "./LeaderboardV2Rows";

interface Props {
    users: Array<User>;
    currentUser: User | undefined;
    sessionsMap: Map<string, Session>;
}

function LeaderboardSessions(props: Props) {

    const [rank, setRank] = useState<number>(0);
    const [rankedVerified, setRankedVerified] = useState<Array<User> | undefined>();

    useEffect(() => {
        (async () => {
            const verifiedArray: Array<User> = props.users
                .filter((user) => {return user.sessionCount > 0})
                .sort((a: User, b: User) => {return b.sessionCount - a.sessionCount})
            setRankedVerified(verifiedArray);
        })();
    }, [props.users]);

    useEffect(() => {
        (async () => {
            if(!rankedVerified) {
                return;
            }
            setRank(0)
            rankedVerified.map((user, index) => {
                if(props.currentUser && user.id === props.currentUser.id) {
                    setRank(index + 1);
                    return;
                }
            });
        })();
    }, [rankedVerified, props.currentUser]);

    return (
        <>
            <PageTracking />
            {props.currentUser && <>
            <LeaderboardNav currentUser={props.currentUser} />
            {rankedVerified && (props.currentUser.enableUiV2 ? <V2GlassPanel className="leaderboard-v2-list-card v2-glass-list-panel">
                <div className="leaderboard-v2-summary">
                    {rank > 0 && <span>You&apos;re ranked <b>{rank}{addNumberSuffix(rank)}</b> out of <b>{rankedVerified.filter((user) => !user.socialDisabled && formatTime(user.sessionCount) !== "0h").length}</b></span>}
                    {rank === 0 && <span>You are yet to check-in.</span>}
                </div>
                <LeaderboardV2Rows
                    rows={rankedVerified
                        .filter((user) => !user.socialDisabled)
                        .filter((user) => formatTime(user.sessionCount) !== "0h")
                        .map((user) => ({
                            user,
                            value: formatTime(user.sessionCount),
                            session: props.sessionsMap.get(user.id),
                        }))}
                    linksToTab="sessions"
                    emptyMessage="No check-in time recorded yet."
                />
            </V2GlassPanel> : <Card className={"mb-3"}>
                <Card.Header>
                    {(rank === 0) && <div>You are yet to check-in.</div>}
                    {(rank > 0) && <div>You're ranked: {rank}<small>{addNumberSuffix(rank)}</small> out of {rankedVerified.length}</div>}
                </Card.Header>
                <Card.Body style={{paddingTop: "0.4em"}}>
                    {rankedVerified
                        .filter((user) => {return !user.socialDisabled})
                        .filter((user) => formatTime(user.sessionCount) !== "0h")
                        .map((user: User, index: number) => (
                            <UserRow linksToTab="sessions" countToDisplay={formatTime(user.sessionCount)} key={user.id} index={index} user={user} session={props.sessionsMap.get(user.id)} minWidth="205px"/>
                        ))}
                    {(rankedVerified.length == 0 || rank === 0) && <div className={'loading'}>
                        Loading...
                    </div>}
                </Card.Body>
            </Card>)}
        </>}
        </>
    );
}

export default LeaderboardSessions;
